import React from 'react';
import { Flex } from '@chakra-ui/react';
import { Modal, Button } from '@morressier/alembic';
import { FormProvider, useForm } from 'react-hook-form';
import _ from 'lodash';
import {
  FormFieldDefinition,
  OptionsField
} from '@publishing-engine/domain/types/article';
import { generateValidationSchema } from '../../../../utils/validation';
import { ajvResolver } from '@hookform/resolvers/ajv';
import { FocusIssueSelect } from './FocusIssueSelect';
import { FormFieldFocusSelect } from '@publishing-engine/domain/types/article';

interface Props {
  isOpen: boolean;
  onSubmit: (value: string) => void;
  onCancel: () => void;
  formField: FormFieldFocusSelect;
  value: string;
  config: {
    validationOptions: string[];
    labelOptions: OptionsField;
    guidelineLink?: string;
  };
}

export type ISelectFormState = {
  preference?: {
    [key in 'focusIssue']: string;
  };
};

const FocusIssueSelectUpdateModal: React.FC<Props> = props => {
  const { isOpen, onSubmit, onCancel, config } = props;
  let { formField } = props;
  const defaultValues = _.set(
    {} as ISelectFormState,
    formField.caseDataFields.main,
    props.value
  );
  formField = {
    ...formField, // Keep everything the same
    params: {
      labels: {
        ...formField.params.labels,
        options: config.labelOptions
      },
      validations: {
        ...formField.params.validations,
        options: config.validationOptions
      }
    }
  };
  const schema = generateValidationSchema({
    [formField.name]: formField
  } as Record<string, FormFieldDefinition>);

  const methods = useForm({
    defaultValues,
    resolver: ajvResolver(schema)
  });

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      width="755px"
      closeButtonProps={{
        hidden: true
      }}
    >
      <Flex
        gap={8}
        bgColor="surfacePrimaryFill"
        flexDirection="column"
        borderRadius="base"
      >
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(data => {
              onSubmit(_.get(data, formField.caseDataFields.main));
            })}
          >
            <Flex
              padding={8}
              gap={6}
              bgColor="surfacePrimaryFill"
              flexDirection="column"
              borderRadius="base"
            >
              <Flex maxHeight={700} overflow={'auto'}>
                <FocusIssueSelect
                  config={formField}
                  guidelineLink={config.guidelineLink}
                  editSelect
                />
              </Flex>
              <Flex
                gap={2}
                justifyContent="flex-end"
                alignItems="center"
                alignSelf="stretch"
              >
                <Button
                  variant="secondary"
                  onClick={onCancel}
                  borderRadius="small"
                >
                  Cancel
                </Button>
                <Button variant="primary" type="submit" borderRadius="small">
                  Save Changes
                </Button>
              </Flex>
            </Flex>
          </form>
        </FormProvider>
      </Flex>
    </Modal>
  );
};

export default FocusIssueSelectUpdateModal;
